/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedCrossIcon20Regular = forwardRef('MedCrossIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 3A1.5 1.5 0 0 1 8 1.5h4A1.5 1.5 0 0 1 13.5 3v3.5H17A1.5 1.5 0 0 1 18.5 8v4a1.5 1.5 0 0 1-1.5 1.5h-3.5V17a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 17v-3.5H3A1.5 1.5 0 0 1 1.5 12V8A1.5 1.5 0 0 1 3 6.5h3.5V3ZM12 3H8v4.25a.75.75 0 0 1-.75.75H3v4h4.25a.75.75 0 0 1 .75.75V17h4v-4.25a.75.75 0 0 1 .75-.75H17V8h-4.25a.75.75 0 0 1-.75-.75V3Z" })));
});
